import {Injectable} from '@angular/core';
import {KeycloakLv1871Service, RuntimeContext, UiConfigService} from '@lv1871/core';

@Injectable()
export class StageConfigService {

  constructor(private _uiConfigService: UiConfigService, private _keycloak: KeycloakLv1871Service) {
  }

  public getInputAutocomplete(): string {
    return this._uiConfigService.settings.environment.name === 'PRODUKTION' ? 'off' : 'on';
  }

  public isVermittlerspezifischesPortfolioMoeglich(): boolean {
    return this._keycloak.getParameter().runtimeContext === RuntimeContext.ANGULAR_SHELL &&
        !!this._keycloak.isAuthenticated();
  }

  public showDevButtonsVermittlerspezifischesPortfolio(): boolean {
    return (this.isVermittlerspezifischesPortfolioMoeglich() &&
        this._keycloak.getParameter().runtimeContext === RuntimeContext.ANGULAR_SHELL &&
        this._uiConfigService.settings.environment.name !== 'PRODUKTION');
  }
}
